/**
 * Is this code running on production server?
 * This is `true` for compiled code deployed on production server only.
 */
export const isProduction = process.env.REACT_APP_PRODUCTION === 'true';

/**
 * Is this code running in a node test environment?
 * This is `true` in code running with `npm test` only.
 */
export const isTestEnvironment = process.env.NODE_ENV === 'test';

/**
 * Is this code not running in a node production environment?
 * This is `false` in compiled code using `npm run build` only.
 */
export const notProductionEnvironment = process.env.NODE_ENV !== 'production';

export const isMockBE = process.env.REACT_APP_MOCKED_BACKEND;

export const shouldShowMockBERoleSwitch =
  process.env.REACT_APP_SHOW_MOCKED_BACKEND_ROLE_SWITH;
